export default "__VITE_ASSET__0Sw1HxMI__"